var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-expansion-panel",
    [
      _c("v-expansion-panel-header", {
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var open = ref.open
              return [
                _c(
                  "v-row",
                  { attrs: { dense: "" } },
                  [
                    _c(
                      "v-col",
                      { staticClass: "text--secondary", attrs: { cols: "12" } },
                      [
                        _c(
                          "v-fade-transition",
                          { attrs: { "leave-absolute": "" } },
                          [
                            open
                              ? _c(
                                  "v-row",
                                  { attrs: { dense: "" } },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        attrs: { cols: "12", sm: "4", md: "3" },
                                      },
                                      [
                                        _c("h3", [
                                          _vm._v(
                                            " Additional Costs Presale Details "
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _c(
                                  "v-row",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: { dense: "" },
                                  },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        attrs: { cols: "12", sm: "4", md: "3" },
                                      },
                                      [
                                        _c("h4", [_vm._v(" Men Days: ")]),
                                        _vm._v(" "),
                                        _c("br"),
                                        _vm._v(
                                          " " + _vm._s(_vm.daysMen || 0) + " "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        attrs: { cols: "12", sm: "4", md: "3" },
                                      },
                                      [
                                        _c("h4", [_vm._v(" Expected Cost: ")]),
                                        _vm._v(" "),
                                        _c("br"),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.FormatMoney(
                                                _vm.expectedCost || 0
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
      _c(
        "v-expansion-panel-content",
        [
          _c(
            "v-row",
            { attrs: { dense: "" } },
            [
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "6", md: "4", lg: "3" } },
                [
                  _c("pga-text-field", {
                    attrs: { label: "Business Lines", readonly: "" },
                    model: {
                      value: _vm.businessLine,
                      callback: function ($$v) {
                        _vm.businessLine = $$v
                      },
                      expression: "businessLine",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "6", md: "4", lg: "3" } },
                [
                  _c("pga-text-field", {
                    attrs: { label: "Tech Area", readonly: "" },
                    model: {
                      value: _vm.techArea,
                      callback: function ($$v) {
                        _vm.techArea = $$v
                      },
                      expression: "techArea",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "9", lg: "6" } },
                [
                  _c("pga-text-field", {
                    attrs: { label: "Supply Tipology", readonly: "" },
                    model: {
                      value: _vm.supplyTipology,
                      callback: function ($$v) {
                        _vm.supplyTipology = $$v
                      },
                      expression: "supplyTipology",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-row",
            { attrs: { dense: "" } },
            [
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "3" } },
                [
                  _c("pga-text-field", {
                    attrs: { label: "Professional Figure", readonly: "" },
                    model: {
                      value: _vm.professionalFigure,
                      callback: function ($$v) {
                        _vm.professionalFigure = $$v
                      },
                      expression: "professionalFigure",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "4" } },
                [
                  _c("pga-text-field", {
                    attrs: { label: "Company", readonly: "" },
                    model: {
                      value: _vm.company,
                      callback: function ($$v) {
                        _vm.company = $$v
                      },
                      expression: "company",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "4" } },
                [
                  _c("pga-text-field", {
                    attrs: { label: "Resource Name", readonly: "" },
                    model: {
                      value: _vm.resourceName,
                      callback: function ($$v) {
                        _vm.resourceName = $$v
                      },
                      expression: "resourceName",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-row",
            { attrs: { dense: "" } },
            [
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "2" } },
                [
                  _c("pga-number-field", {
                    attrs: { label: "Days/Men", decimal: "", readonly: "" },
                    model: {
                      value: _vm.daysMen,
                      callback: function ($$v) {
                        _vm.daysMen = $$v
                      },
                      expression: "daysMen",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "4", md: "2" } },
                [
                  _c("pga-currency-field", {
                    attrs: { label: "Daily Cost", readonly: "" },
                    model: {
                      value: _vm.dailyCost,
                      callback: function ($$v) {
                        _vm.dailyCost = $$v
                      },
                      expression: "dailyCost",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "4", md: "2" } },
                [
                  _c("pga-currency-field", {
                    attrs: { label: "Expected Cost", readonly: "" },
                    model: {
                      value: _vm.expectedCost,
                      callback: function ($$v) {
                        _vm.expectedCost = $$v
                      },
                      expression: "expectedCost",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }